import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import _typeof from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
export function parseTemplate(template, data) {
  var reg = new RegExp('{{([^}]*)}}', 'gi');
  return (template || '').replace(reg, function ($1, key) {
    var arr = key.split('.');
    var val = data;

    for (var i = 0; i < arr.length; i += 1) {
      // eslint-disable-next-line no-shadow
      var _key = arr[i].trim();

      val = val[_key];
    }

    return val || '';
  });
}
export function removeHttp(src) {
  if (!src) return src;

  if (_typeof(src) === 'object' && src.backgroundImage) {
    // eslint-disable-next-line no-param-reassign
    src.backgroundImage = src.backgroundImage.replace(/^http(s?):/, '');
    return src;
  }

  return src.replace(/^http(s?):/, '');
}
/**
 * 截取字符串
 * @param {string} str
 * @param {number} len
 * @return {string}
 */

export function cutStrWithEmoji(str, len) {
  if (typeof str !== 'string') {
    return str;
  }

  var length = 0;
  var strArr = Array.from(str); // ES6的Array.from支持代理对的解析

  var strArrlen = strArr.length;
  var result = ''; // eslint-disable-next-line no-plusplus

  for (var i = 0; i < strArrlen; i++) {
    var item = strArr[i];
    length += 1;

    if (escape(item).length > 4) {
      // 中文或表情符编码后长度大于4，按两个字符的宽度计算
      length += 1;
    }

    result = result.concat(item);

    if (length >= len) {
      if (i === strArrlen - 1) {
        return result;
      }

      result = result.concat('...');
      return result;
    }
  }

  return str;
}
export function replaceUrl(href) {
  var noRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!href) return;

  try {
    var url = window.location.protocol + removeHttp(href);

    if (!window.history.replaceState) {
      window.location.replace(url);
      return;
    }

    window.history.replaceState(null, document.title, url); // 需要替换url同时不刷新网页，则不执行location.replace

    if (!noRefresh) {
      window.location.replace('');
    }
  } catch (e) {
    console.error(e);
  }
}
export function getDefaultAvatar() {
  return '//thirdqq.qlogo.cn/g?b=sdk&k=4Hfd8rBxU0Nz2cIoFCMQRg&s=100&t=0';
}
export function setTitle(title) {
  if (title === undefined || window.document.title === title) {
    return;
  }

  document.title = title; // if (isIos && !isDesktop) {

  var iframe = document.createElement('iframe');
  iframe.style.display = 'none'; // 替换成站标favicon路径或者任意存在的较小的图片即可

  iframe.setAttribute('src', '/favicon.ico');

  var iframeCallback = function iframeCallback() {
    setTimeout(function () {
      iframe.removeEventListener('load', iframeCallback);
      document.body.removeChild(iframe);
    }, 0);
  };

  iframe.addEventListener('load', iframeCallback);
  document.body.appendChild(iframe); // }
}
export function isSameDay(_day1, _day2) {
  var day1;
  var day2;

  if (String(_day1).length <= 10) {
    day1 = _day1 * 1000;
  }

  if (String(_day2).length <= 10) {
    day2 = _day2 * 1000;
  }

  day1 = new Date(_day1).setHours(0, 0, 0, 0);
  day2 = new Date(_day2).setHours(0, 0, 0, 0);
  return day1 === day2;
}
export function isToday(timestamp) {
  if (String(timestamp).length <= 10) {
    // eslint-disable-next-line no-param-reassign
    timestamp *= 1000;
  } // TODO 使用服务器时间


  var todayStart = new Date().setHours(0, 0, 0, 0); // const todayEnd = new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1);

  return timestamp >= todayStart;
}